import '../Styles/IconsPlacer.css';
import ph from '../Resource/telephone.png';
import wh from '../Resource/whatsapp.png';
import dl from '../Resource/download.png';
import {
  getCampaignId,
  getConversionLabel,
  gtag_report_conversion,
} from './ConversionHandler.js';

import React from 'react';

export const IconsPlacer = () => {
  const campaignId = getCampaignId();

  const handlePhoneClick = () => {
    const label = getConversionLabel('phone', campaignId);
    console.log('📞 Phone icon clicked - Conversion Label:', label);
    gtag_report_conversion('tel:+919986800600', label);
  };

  const handleWhatsAppClick = () => {
    const label = getConversionLabel('whatsapp', campaignId);
    console.log('💬 WhatsApp icon clicked - Conversion Label:', label);
    gtag_report_conversion('https://wa.me/919986800600', label);
  };

const handleBrochureDownload = () => {
  const label = getConversionLabel('broucher', campaignId);
  const brochureUrl = 'https://secondinnings.in/Broucher/Prasiddh_broucher.pdf';

  console.log('📥 Brochure icon clicked - Conversion Label:', label);

  const callback = () => {
    console.log('✅ Conversion recorded. Opening brochure...');
    window.open(brochureUrl, '_blank');
  };

  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: label,
      value: 1.0,
      currency: 'INR',
      event_callback: callback
    });
  } else {
    console.warn('⚠️ gtag not available. Opening brochure directly.');
    window.open(brochureUrl, '_blank');
  }
};



  return (
    <div>
      <div className='contact-icons-placer'>
        <div
          className='contact-icon icon-whatsapp'
          onClick={handleWhatsAppClick}
        ></div>
        <div
          className='contact-icon icon-phone'
          onClick={handlePhoneClick}
        ></div>
      </div>

      <div className='broucher-btn-placer'>
        <div
          className='broucher-icon'
          onClick={handleBrochureDownload}
        ></div>
      </div>
    </div>
  );
};
